import store from "../redux/store";
import EnvSettings from "./EnvSettings";

const { requestErrorHandler, getToken } = require("./Common");
const server = EnvSettings.server;

/**
 * Generates the request options with the call body object
 *
 * @param {json} call_body
 * @param {AbortController} abortcontroller
 * @returns
 */
const getRequestOptions = (call_body, abortcontroller) => {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      token: getToken(),
      ...(call_body || {}),
    }),
    ...(abortcontroller ? { signal: abortcontroller.signal } : {}),
  };
};

/**
 *
 * @param {json} result
 * @param {string} data_id
 * @param {function} callback
 * @returns JSON
 */
const returnHandler = (result, data_id, callback) => {
  requestErrorHandler(result, store.dispatch);
  if (callback) {
    return callback(result);
  }
  if (!result.error) {
    return result[data_id];
  }
};

const fetchWrapper = async (
  endpoint,
  data_id,
  call_body,
  callback,
  abortcontroller
) => {
  const requestOptions = getRequestOptions(call_body, abortcontroller);
  return await fetch(server + endpoint, requestOptions)
    .then((res) => res.json())
    .then((result) => {
      return returnHandler(result, data_id, callback);
    })
    .catch((error) => {
      if (error?.name === "AbortError") {
        return;
      }
      requestErrorHandler(error, store.dispatch);
    });
};

/**
 * Get Maintenance Tickets
 *
 * @param {JSON} call_body api call options
 * {
 * 	states: [],
 * 	not_states: [],
 * 	DeviceId: number,
 * 	AssigneeId: number,
 * 	ContactId: number,
 * 	CompanyId: number,
 * 	limit: number
 * }
 * @param {Function} callback custom callback for the result {tickets: []}
 * @returns Array<JSON>
 */

export const getTickets = async (call_body, callback, abortcontroller) => {
  return fetchWrapper(
    "/get_tickets",
    "tickets",
    call_body,
    callback,
    abortcontroller
  );
};

/**
 * Get Devices
 *
 * @param {JSON} call_body api call options
 * {
  search_value: string, search for serial number likeness
  lcState: string,
  requireLCS: boolean, defaults to true
  lcLocation: string,
  lcClient: string,
  color: string,
  hide3Module: boolean,
  OrderId: number,
  hideSecondClass: boolean,
 * }
 * @param {Function} callback custom callback for the result {devices: []}
 * @param {AbortController} abortcontroller
 * @returns Array<JSON>
 */

export const getDevices = async (call_body, callback, abortcontroller) => {
  return fetchWrapper(
    "/get_admin_devices",
    "devices",
    call_body,
    callback,
    abortcontroller
  );
};

/**
 * Get Companies
 *
 * @param {JSON} call_body api call options
 * @param {Function} callback custom callback for the result {companies: []}
 * @param {AbortController} abortcontroller
 * @returns Array<JSON>
 */
export const getCompanies = async (call_body, callback, abortcontroller) => {
  return fetchWrapper(
    "/get_companies",
    "companies",
    call_body,
    callback,
    abortcontroller
  );
};
